import './instrument';
import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { AuthGate } from './auth/auth-gate';
import { CaesarsJwtAuthAdapter } from './auth/caesars-jwt-auth-adapter';
import { LanguageProvider } from './i18n/language-provider';
import { BetSlipProvider } from './bet-slip/bet-slip-provider';
import { CaesarsBetSlipHandoff } from '@s2w/adapter-caesars/bet-slip';
import { CaesarsParentMessaging } from '@s2w/adapter-caesars/parent-messaging';
import { ParentMessagingProvider } from './parent-messaging/parent-messaging-provider';
import { env } from './env';
import './styles.css';

const queryClient = new QueryClient();

const authAdapter = new CaesarsJwtAuthAdapter({
  apiBaseUrl: env.VITE_API_BASE_URL,
});

const betSlipPort = new CaesarsBetSlipHandoff({
  target: window.parent,
  targetOrigin: env.VITE_PARENT_ORIGIN,
});

// Takes the whole window, not `window.parent`: where a message is addressed
// depends on whether anything frames the Game, which it can only tell at send
// time (CAE-1655). The bet slip handoff above deliberately keeps the framed-only
// path — offering it on a channel whose delivery cannot be confirmed is a
// commercial decision, not this fix's (CAE-1345).
const parentMessaging = new CaesarsParentMessaging({
  window,
  targetOrigin: env.VITE_PARENT_ORIGIN,
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthGate adapter={authAdapter}>
          <ParentMessagingProvider port={parentMessaging}>
            <BetSlipProvider port={betSlipPort}>
              <RouterProvider router={router} />
            </BetSlipProvider>
          </ParentMessagingProvider>
        </AuthGate>
      </LanguageProvider>
    </QueryClientProvider>
  </StrictMode>,
);
